import { makeStyles } from "@material-ui/core";

export const SimTrackingHomeCss = makeStyles(() => ({

    textV1: {
        fontWeight: 300,
        fontSize: 12
    },
    textV2: {
        fontSize: 22,
        fontWeight: 'bold',
        marginTop: 1
    },
    textV3: {
        marginTop: 1
    },
    playCircleCss: {
        color: '#0033cc',
        fontSize: '4em'
    },
    divAbsolute: {
        position: 'absolute', top: '80px', left: '12em'
    },
    divAlign: {
        display: 'flex', alignItems: 'center'
    },
    divV1: {
        textAlign: 'center', fontSize: 12
    },
    gridIcon: {
        fontSize: '6em'
    },
    divStep: {
        fontSize: 13, color: '#0033cc', fontWeight: 'bold'
    },
    divDetails: {
        fontWeight: 'bold', fontSize: 16
    },
    divV2: {
        fontSize: 12, color: 'grey'
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.7)",
        color: "darkgrey"
    },
    mtV2: {
        marginTop: 14
    },
    divEnd: {
        backgroundColor: '#E8E8E8', paddingTop: '1em', paddingBottom: '1em', textAlign: 'center', fontSize: 12, marginTop: 8
    },
    colorV1: {
        color: '#0033cc'
    },
    colorV2: {
        color: 'darkgrey'
    },
    divV3: {
        display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10
    },
    cursorPointer: {
        cursor: 'pointer'
    }
}))